function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcQuotationsProposalsSubmodule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.533 392.533",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC10D"
    },
    points: "257.552,64.776 134.982,64.776 148.945,21.786 243.588,21.786 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 103.628,
    y: 147.523,
    style: {
      fill: "#56ACE0"
    },
    width: 33.681,
    height: 33.681
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.628,
    y: 269.446,
    style: {
      fill: "#56ACE0"
    },
    width: 33.681,
    height: 33.681
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M328.469,30.19h-59.281l-7.37-22.626C260.331,2.974,256.129,0,251.41,0H141.123 c-4.719,0-8.857,3.038-10.343,7.499l-7.37,22.626H64.065c-18.036,0-32.711,14.675-32.711,32.711v296.986 c0,18.036,14.675,32.711,32.711,32.711h264.404c18.036,0,32.711-14.675,32.711-32.711V62.901 C361.18,44.865,346.57,30.19,328.469,30.19z M148.945,21.786h94.578l13.964,42.99H134.982L148.945,21.786z M339.394,359.822 c0,6.012-4.848,10.925-10.925,10.925H64.065c-6.012,0-10.925-4.849-10.925-10.925V62.901c0-6.012,4.848-10.925,10.925-10.925h52.234 l-6.594,20.234c-2.457,5.495,2.004,14.222,10.343,14.287h152.566c5.947,0.388,12.8-6.077,10.343-14.287l-6.529-20.234h52.17 c6.012,0,10.925,4.848,10.925,10.925v296.921H339.394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M328.469,51.976h-52.17l6.594,20.234c2.457,8.145-4.396,14.675-10.343,14.287H119.984 c-8.339-0.065-12.8-8.792-10.343-14.287l6.594-20.234h-52.17c-6.012,0-10.925,4.848-10.925,10.925v296.663 c0,6.012,4.848,10.925,10.925,10.925h264.404c6.012,0,10.925-4.848,10.925-10.925V62.901 C339.394,56.889,334.481,51.976,328.469,51.976z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M148.234,125.996H92.768c-6.012,0-10.925,4.848-10.925,10.925v55.467 c0,6.012,4.848,10.925,10.925,10.925h55.467c6.012,0,10.925-4.848,10.925-10.925v-55.467 C159.095,130.909,154.246,125.996,148.234,125.996z M137.309,181.527h-33.681v-33.681h33.681L137.309,181.527L137.309,181.527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M148.234,247.984H92.768c-6.012,0-10.925,4.848-10.925,10.925v55.467 c0,6.012,4.848,10.925,10.925,10.925h55.467c6.012,0,10.925-4.848,10.925-10.925v-55.467 C159.095,252.832,154.246,247.984,148.234,247.984z M137.309,303.451h-33.681V269.77h33.681L137.309,303.451L137.309,303.451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M303.644,131.62H196.267c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h107.378c6.012,0,10.925-4.848,10.925-10.925S309.721,131.62,303.644,131.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M196.267,197.818h42.861c6.012,0,10.925-4.848,10.925-10.925c0-6.012-4.848-10.925-10.925-10.925 h-42.861c-6.012,0-10.925,4.848-10.925,10.925C185.341,192.97,190.255,197.818,196.267,197.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M303.644,253.543H196.267c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h107.378c6.012,0,10.925-4.848,10.925-10.925C314.57,258.392,309.721,253.543,303.644,253.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M239.127,297.891h-42.861c-6.012,0-10.925,4.849-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h42.861c6.012,0,10.925-4.848,10.925-10.925C250.053,302.739,245.204,297.891,239.127,297.891z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuotationsProposalsSubmodule);
export default __webpack_public_path__ + "static/media/ic_quotations_proposals_submodule.08685be172a82839de2e41dd99bcc738.svg";
export { ForwardRef as ReactComponent };